
<b-container>
  <b-row>
    <b-col>
      <b-card no-body class="m-3" v-for="category_node in category_nodes" :key="category_node.id">
        <b-card-header header-bg-variant="secondary" header-text-variant="white">
          {{ category_node.name }}
        </b-card-header>
        <b-card-body>
          <b-container>
            <b-row>
              <b-col sm="12" md="12" lg="6" xl="4" v-for="node in nodes_by_category_node_id[category_node.id]" :key="node.id">
                <b-card class="mb-3">
                  <b-card-title v-if="productTitle(node)">
                    {{productTitle(node)}}
                  </b-card-title>
                  <b-card-sub-title v-if="productSubtitle(node)">
                    {{productSubtitle(node)}}
                  </b-card-sub-title>
                  <b-card-text>
                    <div v-if="productText(node)">
                      {{productText(node)}}
                    </div>
                    <ul v-if="productBullets(node).length > 0">
                      <li v-for="text_item in productBullets(node)">{{text_item}}</li>
                    </ul>
                    <p class="text-secondary m-3"><strong>MSRP {{formatCurrency(node.calculated_price_transformations['esup'])}}</strong></p>
                  </b-card-text>
                  <b-button variant="primary" v-on:click="addToQuote(node)">Add To Quote</b-button>
                  <b-button v-if="productInfoHref(node)" variant="outline-primary" class="ml-3" :href="productInfoHref(node)" target="_blank" rel="noopener noreferrer">Read More</b-button>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</b-container>
